import { Route } from "react-router-dom";

import CheckEmailFuitesDonneesPage from "features/breaches/pages/RegistrationFuiteDonnees/CheckEmailFuitesDonneesPage";
import CommonsConfirmation from "features/auth/pages/CommonsConfirmation";
import ConfirmPhone from "components/ConfirmPhone";
import DWAnalysisResults from "features/darkweb/pages/DarkWeb/DWAnalysisResults";
import DiagnosticPage from "features/diagnostic/pages/Diagnostic/DiagnosticPage";
import FiligraneImporterPage from "features/filigrane/pages/FiligraneImporter/FiligraneImporterPage";
import ForgetPassword from "features/auth/pages/ForgetPassword";
import Home from "components/Home";
import IDTrackerRequest from "features/breaches/pages/IDTrackerRequest";
import Layout from "components/Layout";
import Login from "features/auth/pages/Login";
import MFASetupPage from "features/mfa/pages/MFASetup/MFASetupPage";
import MFAVerifyCode from "features/mfa/pages/MFAVerifyCode/MFAVerifyCode";
import MFAVerifyPage from "features/mfa/pages/MFAVerify/MFAVerifyPage";
import MFAWaitingPage from "features/mfa/pages/MFAWaiting/MFAWaitingPage";
import MiniGoogleLens from "features/fraud/pages/miniGoogleLens/miniGoogleLens";
import NotFoundPage from "pages/NotFoundPage";
import NotificationAll from "features/notifications/pages/NotificationAll";
import OpenLeaksPage from "features/openleak/pages/OpenLeaks/OpenLeaks";
import PricingFuitesDonneesPage from "features/breaches/pages/RegistrationFuiteDonnees/PricingFuitesDonneesPage";
import Register from "features/auth/pages/Register";
import RegistrationFuitesDonneesPage from "features/breaches/pages/RegistrationFuiteDonnees/RegistrationFuitesDonneesPage";
import ResetPasswordPage from "features/auth/pages/ResetPasswordPage";
import SouscriptionPage from "features/darkweb/pages/DarkWeb/SouscriptionPage";
import TallyForm from "features/tally/pages/tally/tally";
import TestAI from "features/ai-assistant/pages/AI_Chat/TestAI";
import UsageDashboard from "features/ai-assistant/components/AI_Dashboard/UsageDash oard";
export const mainRoutesOpen = (
    <>
      <Route
        path="/"
        element={<Home
          forOnlyPartner={!!+(process.env.REACT_APP_FOR_PARTNER_ONLY||0)}
          forADVEnableSSO={!!+(process.env.REACT_APP_FOR_ENABLE_SSO||0)}
        />}
      />
      <Route
        path="/particuliers/register"
        element={<Register />}
      />
      <Route
        path="/particuliers/register/:referralCode"
        element={<Register />}
      />
      <Route
        path="/particuliers/register/new/:domainAssistant/:offreIdFromWordpress"
        element={<Register />}
      />
      <Route
        path="/particuliers/login/new/:domainAssistant/:offreIdFromWordpress"
        element={<Login />}
      />
      <Route
        path="/particuliers/login"
        element={<Login />}
      />
      <Route
        path="/particuliers/diagnostic"
        element={
          <Layout>
            <DiagnosticPage />
          </Layout>
        }
      />
      <Route
        path="/diagnostic"
        element={<DiagnosticPage />}
      />
      <Route
        path="/professionnels/diagnostic"
        element={<DiagnosticPage />}
      />
      <Route
        path="/professionnels/login"
        element={<Login
          forOnlyPartner={!!+(process.env.REACT_APP_FOR_PARTNER_ONLY||0)}
          forADVEnableSSO={!!+(process.env.REACT_APP_FOR_ENABLE_SSO||0)}
        />}
      />
      <Route
        path="/professionnels/register"
        element={<Register />}
      />
      <Route
        path={`/commons/confirmation`}
        element={<CommonsConfirmation />}
      />
      <Route
        path={`/commons/password`}
        element={<ResetPasswordPage />}
      />
      <Route
        path="/particuliers/request"
        element={<IDTrackerRequest />}
      />
      <Route
        path="/filter"
        element={<FiligraneImporterPage />}
      />
      <Route
        path="/confirmPhone"
        element={<ConfirmPhone />}
      />
      <Route
        path="/resend"
        element={<ForgetPassword />}
      />
      <Route
        path="*"
        element={<NotFoundPage />}
      />

      <Route
        path="/dark-web"
        element={
          <main>
            <div className="content">
              <DWAnalysisResults />
            </div>
          </main>
        }
      />

      <Route
        path="/accompaniment-form"
        element={
          <main>
            <div className="content">
              <TallyForm />
            </div>
          </main>
        }
      />

      <Route
        path="/mini-google-lens"
        element={
          <main>
            <div className="content">
              <MiniGoogleLens />
            </div>
          </main>
        }
      />

      <Route
        path="/id-assistant-ai"
        element={
          <main>
            <div className="content">
              <TestAI />
            </div>
          </main>
        }
      />

      <Route
        path="/test-ai-dashboard"
        element={
          <main>
            <div className="content">
              <UsageDashboard />
            </div>
          </main>
        }
      />

      <Route
        path="/souscription/:offerHeadRoute/:offer/:isMonthActive"
        element={
          <main>
            <div className="content">
              <SouscriptionPage />
            </div>
          </main>
        }
      />
      <Route
        path="/fuites-donnees"
        element={<CheckEmailFuitesDonneesPage />}
      />

      <Route
        path="fuites-donnees/active-id-tracker/new"
        element={<RegistrationFuitesDonneesPage />}
      />
      <Route
        path="fuites-donnees/pricing"
        element={<PricingFuitesDonneesPage />}
      />

      <Route path="/mfa/setup" element={<MFASetupPage />} />
      <Route path="/mfa/verify" element={<MFAVerifyPage />} />
      <Route path="/mfa/verify-code" element={<MFAVerifyCode />} />
      <Route path="/mfa/waiting" element={<MFAWaitingPage />} />

      <Route path="/open-leaks" element={<OpenLeaksPage />} />
    </>
  );

export const mainRoutesProtected = (
    <>
      <Route
        path="/notifications"
        element={
          <Layout>
            <NotificationAll />
          </Layout>
        }
      />

      {/*<Route
                path="/dark-web-test"
                element={
                    <main>
                        <div className="content">
                            <DatabaseDocuments />
                        </div>
                    </main>
                }
            />*/}
    </>
  );

